import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import Navbar from './Navbar/Navbar';
import { PromoBanner } from '../PromoBanner/PromoBanner';
import { getUtmQueryString } from '../../helpers/utmCookie';
import { styles } from './styles';
import Banner from '../Banner/Banner';

function Header() {
  const [lkLinks, setLkLinks] = useState({});
  const lkUrl = 'https://edu.elbrusboot.camp/';
  const utmQuery = getUtmQueryString();
  useEffect(() => {
    setLkLinks({
      enter: `${lkUrl}courses/js/textbook/${utmQuery ? `?${utmQuery}` : ''}`,
      demo: `${lkUrl}?register==${utmQuery ? `?${utmQuery}` : ''}`,
    });
  }, [utmQuery]);
  return (
    <Box component="header" sx={styles.header}>
      <Navbar lkLinks={lkLinks} />
      <Banner />
    </Box>
  );
}

export default Header;
